import Modal from 'react-modal'
import SubscriptionOptions from './SubscriptionOptions'
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg'

const SubscriptionModal = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {}}
      className="modal w-[775px]"
      overlayClassName="modal-overlay"
    >
      <div className="p-12 rounded-t relative min-h-[300px]">
        <div className="font-heading font-bold  text-4xl">
          <span className="text-salmon">Sharefolio</span> Paid Plan
        </div>
        <div className="mt-6">
          <p>
            Purchase the Sharefolio paid plan and gain access to unlimited
            tracks, portfolios and players for only $5 a month or $50 a year!
          </p>
        </div>
        <div className="mt-10">
          <SubscriptionOptions />
        </div>

        <button className="p-4 absolute top-0 right-0" onClick={onRequestClose}>
          <CloseIcon fill="#CCC" height="26" />
        </button>
      </div>
    </Modal>
  )
}

export default SubscriptionModal
